/* eslint-disable arrow-body-style */
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { NavLink } from 'react-router-dom';

import ROUTES from '../../data/routes';

const PanelSidebar = ({ cartUsersPermission, purchasePermission, limit }) => (
  <div className="box-aside box-aside--left">
    <ul className="aside-navigation">
      {/* <li>
          <NavLink activeClassName="active" to={ROUTES.PANEL}>Geral</NavLink>
        </li>
        <li>
          <NavLink activeClassName="active" to={ROUTES.PANEL_ACCOUNT}>Informações da conta</NavLink>
        </li>
       */}
      {cartUsersPermission && (
        <li>
          <NavLink
            activeClassName="active"
            to={ROUTES.PANEL_CARTS_TO_APPROVE}
          >
            {I18n.t('cartToApproveTwo')}
            {' '}
            <svg className="icon icon-arrow-right"><use xlinkHref="#icon-arrow-right" /></svg>
          </NavLink>
        </li>
      )}
      {(!purchasePermission || limit) && (
        <li>
          <NavLink
            activeClassName="active"
            to={ROUTES.PANEL_CARTS_SOLICITED}
          >
            {I18n.t('mySolicitations')}
            {' '}
            <svg className="icon icon-arrow-right"><use xlinkHref="#icon-arrow-right" /></svg>
          </NavLink>
        </li>
      )}
      <li>
        <NavLink activeClassName="active" to={ROUTES.ORDER_LIST}>
          {I18n.t('documentList2')}
          {' '}
          <svg className="icon icon-arrow-right"><use xlinkHref="#icon-arrow-right" /></svg>
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName="active" to={ROUTES.REPORT}>
          {I18n.t('report')}
          {' '}
          <svg className="icon icon-arrow-right"><use xlinkHref="#icon-arrow-right" /></svg>
        </NavLink>
      </li>
      <li>
        <NavLink activeClassName="active" to={ROUTES.INVOICE_DEVOLUTION_LIST}>
          {I18n.t('invoiceDevolutions')}
          {' '}
          <svg className="icon icon-arrow-right"><use xlinkHref="#icon-arrow-right" /></svg>
        </NavLink>
      </li>
    </ul>
  </div>
);

const mapStateToProps = state => ({
  cartUsersPermission: state.contracts.selected && state.contracts.selected.cartUsersPermission,
  purchasePermission: state.contracts.selected && state.contracts.selected.purchasePermission,
  limit: state.contracts.selected && state.contracts.selected.limit,
});

export default connect(mapStateToProps)(PanelSidebar);
